import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { List, Set } from "immutable";

import { getImages } from "data/assets";

import { getParentSectionId } from "data/voting-form/parent-section";

import { getCampaign as getParentCampaign } from "data/parent-campaign";

import {
  getCampaignCategories,
  getEntity,
  getEntityMicrositeCampaignId,
  getSelectCategoryCopy,
} from "data/entity";

import {
  getPaginationInfo,
  nextPage as nextPaginationPage,
  setInitialPagination,
} from "data/pagination";

import {
  getAvailableVotes,
  getCampaignThatLaunchedForm,
  getFilteredCampaigns,
  getLoading,
  getPaginationLoading,
  getSelectedCampaigns,
  getSelectedCategory,
  searchCampaignsByEntity,
  selectCampaign,
  selectCategory,
  setQuery,
  getQuery,
} from "data/voting-form/voting";

import { nextPage } from "data/voting-form/routes";

import AmploButton from "shared/ui/amplo-button";
import ModalCampaignItem from "../components/ModalCampaignItem";
import SelectOptions from "lib/components/SelectOptions";
import InputDebounced from "lib/components/InputDebounced";

class SearchInCategory extends React.Component {
  handleCloseModal = () => {
    const { onCloseModal } = this.props;
    onCloseModal();
  };

  handleInput = (e) => {
    e.preventDefault();
    const { setQuery } = this.props;
    const val = e.target.value;

    setQuery(val);

    this.handleSubmit();
  };

  handleSubmit = (e) => {
    const {
      query,
      selectedCategory,
      campaignId,
      entityId,
      sectionId,
      entityMicrositeCampaignId,
    } = this.props;

    const { searchCampaignsByEntity, setInitialPagination } = this.props;

    if (e) {
      e.preventDefault();
    }

    let options = {
      query,
      category: selectedCategory,
      isPaginationLoad: true,
    };

    if (entityMicrositeCampaignId) {
      options = Object.assign(options, { campaignId: entityMicrositeCampaignId });
    } else if (sectionId) {
      options = Object.assign(options, { sectionId });
    } else {
      options = Object.assign(options, { campaignId });
    }

    searchCampaignsByEntity(entityId, options).then(({ offset, total }) => {
      setInitialPagination({ total });
    });
  };

  handlePagination = () => {
    const {
      query,
      selectedCategory,
      entityId,
      sectionId,
      campaignId,
      entityMicrositeCampaignId,
      pagination: { page },
    } = this.props;

    const { nextPaginationPage, searchCampaignsByEntity } = this.props;

    let options = {
      isPaginationLoad: true,
      category: selectedCategory,
      page: page + 1,
      query,
    };

    if (entityMicrositeCampaignId) {
      options = Object.assign(options, { campaignId: entityMicrositeCampaignId });
    } else if (sectionId) {
      options = Object.assign(options, { sectionId });
    } else {
      options = Object.assign(options, { campaignId });
    }

    searchCampaignsByEntity(entityId, options).then(() => {
      nextPaginationPage();
    });
  };

  handleCampaignSelect = (campaign, bool) => {
    const { selectCampaign } = this.props;

    selectCampaign(campaign, bool);
  };

  handleCategorySelect = (selectedCategory) => {
    const { query, entityId, sectionId, campaignId, entityMicrositeCampaignId } =
      this.props;

    const { searchCampaignsByEntity, setInitialPagination, selectCategory } = this.props;

    let options = {
      query,
      category: selectedCategory,
      isPaginationLoad: true,
    };

    if (entityMicrositeCampaignId) {
      options = Object.assign(options, { campaignId: entityMicrositeCampaignId });
    } else if (sectionId) {
      options = Object.assign(options, { sectionId });
    } else {
      options = Object.assign(options, { campaignId });
    }

    selectCategory(selectedCategory);
    searchCampaignsByEntity(entityId, options).then(({ total }) => {
      setInitialPagination({ total });
    });
  };

  componentDidMount() {
    const { campaigns, campaignId, entityId, sectionId, entityMicrositeCampaignId } =
      this.props;

    const { searchCampaignsByEntity, setInitialPagination } = this.props;

    /*
      If we enter this route without going through the select parent workflow,
      we need to populate the store with the campaigns
    */
    if (campaigns.count() <= 1) {
      let opts;

      if (entityMicrositeCampaignId) {
        opts = {
          campaignId: entityMicrositeCampaignId,
        };
      } else if (sectionId) {
        opts = {
          sectionId,
        };
      } else {
        opts = {
          campaignId,
        };
      }

      searchCampaignsByEntity(entityId, opts).then(({ total }) => {
        setInitialPagination({ total });
      });
    }
  }

  renderCampaigns() {
    const {
      campaigns,
      selectedCampaigns,
      pageCount,
      isLoading,
      isPaginationLoading,
      noAvailableVotes,
      setVotes,
      removeCampaign,
      pagination: { hasPagesRemaining },
    } = this.props;

    let content = [];

    if (selectedCampaigns) {
      selectedCampaigns.map((campaign, idx) => {
        const key = `${idx}-${campaign.get("id")}`;
        content.push(
          <ModalCampaignItem
            key={key}
            campaign={campaign}
            isSelected={true}
            setVotes={setVotes}
            removeCampaign={removeCampaign}
            onSelectCampaign={this.handleCampaignSelect}
            noAvailableVotes={noAvailableVotes}
          />,
        );
      });
    }

    if (campaigns) {
      campaigns.map((campaign, idx) => {
        const isInSelected = !!selectedCampaigns.find((selected) => {
          return campaign.get("id") === selected.get("id");
        });

        if (!isInSelected) {
          const key = `${idx}-${campaign.get("name")}`;
          content.push(
            <ModalCampaignItem
              key={key}
              campaign={campaign}
              isSelected={false}
              onSelectCampaign={this.handleCampaignSelect}
            />,
          );
        }
      });
    }

    if (isPaginationLoading) {
      content.push(
        <div key={"spinner"} className="m-md-t text-center">
          <i className="fa fa-3x fa-refresh fa-spin" />
        </div>,
      );
    }

    content.push(
      <div key="load-button" className="m-md-t text-center">
        <AmploButton
          className="load-button primary-color-background"
          hide={isPaginationLoading || !hasPagesRemaining}
          onClick={this.handlePagination}>
          load more campaigns
        </AmploButton>
      </div>,
    );

    if (!isLoading && campaigns.count() === 0 && content.length <= 1) {
      return <div className="m-md-t text-center">No results found!</div>;
    }
    if (content.length > 0) {
      return content;
    }
  }

  render() {
    const {
      campaignCategories,
      images,
      selectedCampaigns,
      selectedCategory,
      selectCategoryCopy,
    } = this.props;

    let categoryImage = selectedCategory && images.get(selectedCategory.toLowerCase());
    let formattedCategory = selectedCategory;

    if (!selectedCategory || selectedCategory === "") {
      formattedCategory = selectCategoryCopy;
      categoryImage = images.get("all_categories");
    } else {
      categoryImage = images.get(selectedCategory.toLowerCase().replace(/ /g, "_"));
    }

    return (
      <div>
        <div className="voting-modal-vote-section">
          <form
            data-testid="t-SearchI-form"
            className="m-md-r"
            onSubmit={this.handleSubmit}>
            <div className="voting-search__input-group">
              <label>Search by Name</label>
              <InputDebounced
                className="voting-search__input"
                onChange={this.handleInput}
                type="search"
                aria-label="Search"
                placeholder="Search..."
              />
              <button
                data-testid="t-SearchI-submit"
                aria-label="Submit"
                className="voting-search-button"
                type="submit">
                <i className="fa fa-search" />
              </button>
            </div>
          </form>

          <div className="voting-counter secondary-color-background">
            <span className="number">{selectedCampaigns.count()}</span>
            <span className="title">Selected</span>
          </div>
        </div>

        <div
          className="search-category primary-color-border"
          style={{ borderWidth: "2px", borderStyle: "solid" }}>
          <span className="search-category-selected">
            <img src={categoryImage} className="search-category-selected-img" />
            <span className="search-category-selected-name">
              {formattedCategory}
              <i className="fa fa-check" />
            </span>
          </span>
          <span className="search-category-drop-down">
            <SelectOptions
              displayText={selectCategoryCopy}
              selected={selectedCategory}
              items={campaignCategories}
              selectItemAction={this.handleCategorySelect}
            />
          </span>
        </div>
        <div className="search-results">{this.renderCampaigns()}</div>
      </div>
    );
  }
}

SearchInCategory.propTypes = {
  campaigns: PropTypes.instanceOf(Set).isRequired,

  isLoading: PropTypes.bool.isRequired,
  availableVotes: PropTypes.number.isRequired,
  query: PropTypes.string,
  selectedCampaigns: PropTypes.instanceOf(List).isRequired,
  selectedCategory: PropTypes.string,
  selectCategoryCopy: PropTypes.string.isRequired,

  images: PropTypes.object.isRequired,
  campaignCategories: PropTypes.instanceOf(List).isRequired,
  campaignId: PropTypes.string.isRequired,
  entityId: PropTypes.string.isRequired,
  sectionId: PropTypes.string,

  searchCampaigns: PropTypes.func.isRequired,
  selectCampaign: PropTypes.func.isRequired,
  selectCategory: PropTypes.func.isRequired,
  setQuery: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  nextPage: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  sectionId: getParentSectionId(state),
  entityId: getEntity(state).get("id"),
  campaignId: getCampaignThatLaunchedForm(state),

  campaignCategories: getCampaignCategories(state),
  campaigns: getFilteredCampaigns(state),

  entityMicrositeCampaignId: getEntityMicrositeCampaignId(state),
  query: getQuery(state),
  selectCategoryCopy: getSelectCategoryCopy(state),
  selectedCategory: getSelectedCategory(state),
  selectedCampaigns: getSelectedCampaigns(state),
  parentCampaign: getParentCampaign(state)("voting_form"),
  availableVotes: getAvailableVotes(state),
  pagination: getPaginationInfo()(state),
  isLoading: getLoading(state),
  isPaginationLoading: getPaginationLoading(state),
  images: getImages(state),
});

const mapActionCreators = {
  nextPage,
  searchCampaignsByEntity,
  selectCampaign,
  selectCategory,
  setQuery,

  nextPaginationPage() {
    return nextPaginationPage();
  },

  setInitialPagination({ total }) {
    return setInitialPagination({
      total,
    });
  },
};

export default connect(mapStateToProps, mapActionCreators)(SearchInCategory);
